export default () => ({
  root: {},
  button_related_keywords: {
    textDecoration: 'none',
    textTransform: 'none',
    padding: 0,
    margin: 0,
  },
});
